var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "card w-modal h-modal", attrs: { id: "supporter-details" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "flex flex-col" }, [
            _c("h1", { staticClass: "mb-2" }, [
              _vm._v(
                "New " + _vm._s(_vm.addDonation ? "Donation" : "Supporter")
              )
            ]),
            _c("h4", [_vm._v("Supporter Details")])
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          },
          [_c("i", { staticClass: "icn icn-x sm" })]
        )
      ]),
      _vm.isValidating
        ? _c("div", { staticClass: "content" }, [_vm._m(0)])
        : _vm._e(),
      !_vm.isValidating
        ? _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "field" }, [
              _c("h2", [_vm._v("Supporter Details")]),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "w-1/4" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payload.supporter.title,
                          expression: "payload.supporter.title"
                        }
                      ],
                      attrs: { required: "" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.payload.supporter,
                            "title",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "Mr" } }, [_vm._v("Mr")]),
                      _c("option", { attrs: { value: "Mrs" } }, [
                        _vm._v("Mrs")
                      ]),
                      _c("option", { attrs: { value: "Ms" } }, [_vm._v("Ms")]),
                      _c("option", { attrs: { value: "Miss" } }, [
                        _vm._v("Miss")
                      ]),
                      _c("option", { attrs: { value: "Dr" } }, [_vm._v("Dr")]),
                      _c("option", { attrs: { value: "Mx" } }, [_vm._v("Mx")])
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.supporter.firstName,
                        expression: "payload.supporter.firstName"
                      }
                    ],
                    attrs: {
                      required: "",
                      type: "text",
                      placeholder: "First name",
                      autocomplete: "nope",
                      maxlength: "127"
                    },
                    domProps: { value: _vm.payload.supporter.firstName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.supporter,
                          "firstName",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.supporter.lastName,
                        expression: "payload.supporter.lastName"
                      }
                    ],
                    attrs: {
                      required: "",
                      type: "text",
                      placeholder: "Last name",
                      autocomplete: "nope",
                      maxlength: "127"
                    },
                    domProps: { value: _vm.payload.supporter.lastName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.supporter,
                          "lastName",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.supporter.phoneNumber,
                        expression: "payload.supporter.phoneNumber"
                      }
                    ],
                    attrs: {
                      id: "phone-number",
                      type: "text",
                      pattern: "^(\\(?\\+?[0-9]*\\)?)?[0-9_\\- \\(\\)]*$",
                      title: "E.g: +61452609946 | 0452609946",
                      placeholder: "Phone (optional)",
                      autocomplete: "nope",
                      maxlength: "255"
                    },
                    domProps: { value: _vm.payload.supporter.phoneNumber },
                    on: {
                      keydown: function($event) {
                        return _vm.removeValidity("#phone-number")
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.supporter,
                          "phoneNumber",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.supporter.email,
                        expression: "payload.supporter.email"
                      }
                    ],
                    attrs: {
                      id: "email",
                      type: "text",
                      pattern: "^[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,}$",
                      title: "E.g: johndoe@example.com",
                      placeholder: "Email (optional)",
                      autocomplete: "nope",
                      maxlength: "255"
                    },
                    domProps: { value: _vm.payload.supporter.email },
                    on: {
                      keydown: function($event) {
                        return _vm.removeValidity("#email")
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.supporter,
                          "email",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm.payload.supporter.email
                ? _c("div", [
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.payload.donation.isOptingIn,
                                expression: "payload.donation.isOptingIn"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.payload.donation.isOptingIn
                              )
                                ? _vm._i(
                                    _vm.payload.donation.isOptingIn,
                                    null
                                  ) > -1
                                : _vm.payload.donation.isOptingIn
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.payload.donation.isOptingIn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.payload.donation,
                                        "isOptingIn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.payload.donation,
                                        "isOptingIn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.payload.donation,
                                    "isOptingIn",
                                    $$c
                                  )
                                }
                              }
                            }
                          }),
                          _vm._v(
                            " Send me emails about important conservation news and how I can help WWF protect the diversity of life on Earth "
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.payload.donation.contactForBequest,
                                expression: "payload.donation.contactForBequest"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.payload.donation.contactForBequest
                              )
                                ? _vm._i(
                                    _vm.payload.donation.contactForBequest,
                                    null
                                  ) > -1
                                : _vm.payload.donation.contactForBequest
                            },
                            on: {
                              change: function($event) {
                                var $$a =
                                    _vm.payload.donation.contactForBequest,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.payload.donation,
                                        "contactForBequest",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.payload.donation,
                                        "contactForBequest",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.payload.donation,
                                    "contactForBequest",
                                    $$c
                                  )
                                }
                              }
                            }
                          }),
                          _vm._v(" Send information in the Will ")
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payload.donation.isOnBehalfOfBusiness,
                          expression: "payload.donation.isOnBehalfOfBusiness"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.payload.donation.isOnBehalfOfBusiness
                        )
                          ? _vm._i(
                              _vm.payload.donation.isOnBehalfOfBusiness,
                              null
                            ) > -1
                          : _vm.payload.donation.isOnBehalfOfBusiness
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.payload.donation.isOnBehalfOfBusiness,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.payload.donation,
                                    "isOnBehalfOfBusiness",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.payload.donation,
                                    "isOnBehalfOfBusiness",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.payload.donation,
                                "isOnBehalfOfBusiness",
                                $$c
                              )
                            }
                          },
                          function($event) {
                            _vm.payload.donation.businessName = null
                          }
                        ]
                      }
                    }),
                    _vm._v(" Donate on behalf of a business ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _vm.payload.donation.isOnBehalfOfBusiness
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.donation.businessName,
                            expression: "payload.donation.businessName"
                          }
                        ],
                        attrs: {
                          required: "",
                          type: "text",
                          placeholder: "Business name",
                          maxlength: "127"
                        },
                        domProps: { value: _vm.payload.donation.businessName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.payload.donation,
                              "businessName",
                              $event.target.value
                            )
                          }
                        }
                      })
                    : _vm._e()
                ])
              ]),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payload.billingAddress.label,
                          expression: "payload.billingAddress.label"
                        }
                      ],
                      attrs: { required: "" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.payload.billingAddress,
                            "label",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.labels, function(l) {
                      return _c("option", { key: l, domProps: { value: l } }, [
                        _vm._v(" " + _vm._s(l) + " ")
                      ])
                    }),
                    0
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "row mt-2" },
                [
                  _c("country-selector", {
                    attrs: { country: _vm.payload.billingAddress.country },
                    on: {
                      countrySelected: function($event) {
                        return _vm.clearAddress($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.payload.billingAddress.country === _vm.australia
                ? _c(
                    "div",
                    { staticClass: "row mt-2" },
                    [
                      _c("autocomplete-address", {
                        key: _vm.supporterFullAddressKey,
                        ref: "autocomplete-address",
                        on: { addressSelected: _vm.getSupporterSelectedAddress }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.billingAddress.unitNumber,
                        expression: "payload.billingAddress.unitNumber"
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "Unit number",
                      autocomplete: "nope",
                      maxlength: "31"
                    },
                    domProps: { value: _vm.payload.billingAddress.unitNumber },
                    on: {
                      change: function($event) {
                        return _vm.updateAddress()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.billingAddress,
                          "unitNumber",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.billingAddress.streetNumber,
                        expression: "payload.billingAddress.streetNumber"
                      }
                    ],
                    attrs: {
                      required: "",
                      type: "text",
                      placeholder: "Street number",
                      autocomplete: "nope",
                      maxlength: "31"
                    },
                    domProps: {
                      value: _vm.payload.billingAddress.streetNumber
                    },
                    on: {
                      change: function($event) {
                        return _vm.updateAddress()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.billingAddress,
                          "streetNumber",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.billingAddress.streetName,
                        expression: "payload.billingAddress.streetName"
                      }
                    ],
                    attrs: {
                      required: "",
                      type: "text",
                      placeholder: "Street name",
                      autocomplete: "nope",
                      maxlength: "127"
                    },
                    domProps: { value: _vm.payload.billingAddress.streetName },
                    on: {
                      change: function($event) {
                        return _vm.updateAddress()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.billingAddress,
                          "streetName",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.billingAddress.suburb,
                        expression: "payload.billingAddress.suburb"
                      }
                    ],
                    attrs: {
                      required: "",
                      type: "text",
                      placeholder: "Suburb",
                      autocomplete: "nope",
                      maxlength: "63"
                    },
                    domProps: { value: _vm.payload.billingAddress.suburb },
                    on: {
                      change: function($event) {
                        return _vm.updateAddress()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.billingAddress,
                          "suburb",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.billingAddress.postalCode,
                        expression: "payload.billingAddress.postalCode"
                      }
                    ],
                    attrs: {
                      required: "",
                      type: "text",
                      placeholder: "Postcode",
                      autocomplete: "nope",
                      maxlength: "15"
                    },
                    domProps: { value: _vm.payload.billingAddress.postalCode },
                    on: {
                      change: function($event) {
                        return _vm.updateAddress()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.billingAddress,
                          "postalCode",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "field" }, [
                  _vm.payload.billingAddress.country === _vm.australia
                    ? _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.payload.billingAddress.state,
                              expression: "payload.billingAddress.state"
                            }
                          ],
                          attrs: { required: "", name: "state" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.payload.billingAddress,
                                  "state",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.updateAddress()
                              }
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "", selected: "" } }, [
                            _vm._v("Select a state")
                          ]),
                          _c("option", { attrs: { value: "NSW" } }, [
                            _vm._v("NSW")
                          ]),
                          _c("option", { attrs: { value: "ACT" } }, [
                            _vm._v("ACT")
                          ]),
                          _c("option", { attrs: { value: "NT" } }, [
                            _vm._v("NT")
                          ]),
                          _c("option", { attrs: { value: "SA" } }, [
                            _vm._v("SA")
                          ]),
                          _c("option", { attrs: { value: "WA" } }, [
                            _vm._v("WA")
                          ]),
                          _c("option", { attrs: { value: "VIC" } }, [
                            _vm._v("VIC")
                          ]),
                          _c("option", { attrs: { value: "QLD" } }, [
                            _vm._v("QLD")
                          ]),
                          _c("option", { attrs: { value: "TAS" } }, [
                            _vm._v("TAS")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.payload.billingAddress.country !== _vm.australia
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.billingAddress.state,
                            expression: "payload.billingAddress.state"
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "State",
                          autocomplete: "nope",
                          maxlength: "63"
                        },
                        domProps: { value: _vm.payload.billingAddress.state },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.payload.billingAddress,
                              "state",
                              $event.target.value
                            )
                          }
                        }
                      })
                    : _vm._e()
                ])
              ])
            ])
          ])
        : _vm._e(),
      !_vm.isValidating
        ? _c("div", { staticClass: "footer" }, [
            _c(
              "button",
              {
                staticClass: "secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_vm._v("Cancel")]
            ),
            !_vm.addDonation
              ? _c(
                  "button",
                  {
                    staticClass: "secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.reset()
                      }
                    }
                  },
                  [_vm._v("Reset")]
                )
              : _vm._e(),
            _c("div", { staticClass: "flex-grow" }),
            !_vm.addDonation
              ? _c(
                  "button",
                  {
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.saveSupporter()
                      }
                    }
                  },
                  [_vm._v("Save")]
                )
              : _vm._e(),
            _c(
              "button",
              {
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.goToNextStep()
                  }
                }
              },
              [_vm._v("Continue to donation")]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-col justify-center items-center h-full" },
      [
        _c("img", {
          staticClass: "h-36",
          attrs: { src: require("@/assets/img/loading.svg") }
        }),
        _c("h2", [_vm._v("Loading")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }